<template>
  <div class="watermark-container" v-if="!isSystemAdmin" :style="{ backgroundImage: `url(${svgUrl})` }">
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AntiPiracyWatermark',
  computed: {
    ...mapGetters(['userEmail', 'isSystemAdmin']),
    svgUrl() {
      const text = `${this.userEmail || 'AlunoEducaMais'} - Material exclusivo do Projeto Asas.`;
      
      const svg = `
        <svg width="600" height="350" xmlns="http://www.w3.org/2000/svg">
          <text 
            x="50%" 
            y="50%" 
            dominant-baseline="middle" 
            text-anchor="middle" 
            fill="rgba(255,255,255,0.075)" 
            font-size="20" 
            font-family="sans-serif" 
            font-weight="bold" 
            transform="rotate(-30 300 175)"
            style="text-shadow: 1px 1px 2px rgba(0,0,0,0.3)"
          >
            ${text}
          </text>
        </svg>
      `;
      return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
    }
  }
}
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none; /* Impede que o usuário clique na marca d'água */
  z-index: 99999;
  background-repeat: repeat;
  background-position: center;
}
</style>
